import { useRef } from 'react';
import { IReactToPrintProps, useReactToPrint } from 'react-to-print';

export const usePrintWithRef = (props: IReactToPrintProps) => {
  const printRef = useRef<HTMLDivElement>(null);

  const handleReactToPrint = useReactToPrint(props);

  const handlePrint = () => handleReactToPrint(null, () => printRef.current);

  return {
    printRef,
    handlePrint,
  };
};
